import { render, staticRenderFns } from "./EditInvoiceService.vue?vue&type=template&id=038a2a70"
import script from "./EditInvoiceService.vue?vue&type=script&lang=js"
export * from "./EditInvoiceService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports